document.addEventListener('DOMContentLoaded', initTrackOrderFormHandler);

function getStatusFromChangeDates(statusChangeDates) {
    if (!statusChangeDates) {
        return '';
    }
    
    const statusPriority = ['90', '2', '3', '80', '70', '60', '20', '1', '95', '96', '97', '98', '81', '92'];
    
    for (const statusCode of statusPriority) {
        if (statusChangeDates[statusCode]) {
            return statusCode;
        }
    }
    
    return '';
}

function initTrackOrderFormHandler() {
    
    const trackOrderForm = document.getElementById('track-order-form');
    
    if (!trackOrderForm) {
        return;
    }
    
    
    const errorMessage = document.getElementById('track-order-error-message');
    const errorText = errorMessage?.querySelector('p.banner__content.form-error');
    const submitButton = document.getElementById('track-order-submit-button');
    const pizzabarContainer = document.getElementById('track-order-pizzabar-container');
    const orderTableContainer = document.getElementById('track-order-table-container');

    if (!submitButton) {
        return;
    }

    const submitButtonDefaultHtml = submitButton.innerHTML;
    const submitButtonLoadingText = 'טוען...';
    const submitButtonLoadingHtml = `<span class="boa-track-order-submit-spinner" aria-hidden="true"></span>${submitButtonLoadingText}`;

    function setSubmitButtonLoading(isLoading) {
        if (isLoading) {
            submitButton.disabled = true;
            submitButton.classList.add('is-loading');
            submitButton.setAttribute('aria-busy', 'true');
            submitButton.innerHTML = submitButtonLoadingHtml;
        } else {
            submitButton.disabled = false;
            submitButton.classList.remove('is-loading');
            submitButton.removeAttribute('aria-busy');
            submitButton.innerHTML = submitButtonDefaultHtml;
        }
    }
    
    trackOrderForm.addEventListener('submit', async (event) => {
        event.preventDefault();
        
        if (!submitButton) {

            return;
        }
        
        setSubmitButtonLoading(true);
        
        errorMessage?.classList.add('hide-down');
        pizzabarContainer?.classList.add('hide-down');
        orderTableContainer?.classList.add('hide-down');
        
        const formData = new FormData(trackOrderForm);
        const orderEmail = formData.get("email");
        const orderName = formData.get("order_number");

        try {
            const body = {
                orderName: orderName,
                orderEmail: orderEmail
            };
            
            const response = await fetch('/apps/api/orders/status/details', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            });

            if (!response.ok) {
                throw new Error('שגיאה בטעינת פרטי ההזמנה. אנא בדוק את הפרטים שהזנת ונסה שוב.');
            }

            const contentType = response.headers.get('content-type');
            if (!contentType || !contentType.includes('application/json')) {
                throw new Error('שגיאה בטעינת פרטי ההזמנה. אנא בדוק את הפרטים שהזנת ונסה שוב.');
            }

            const responseJson = await response.json();
            
            if (!responseJson.success) {
                throw new Error(responseJson.message || 'שגיאה בטעינת פרטי ההזמנה. אנא בדוק את הפרטים שהזנת ונסה שוב.');
            }
            
            if (!responseJson.statusChangeDates){
                throw new Error('הזמנה לא נמצאה. אנא בדוק את כתובת המייל ומספר ההזמנה שהזנת.');
            }

            const pizzabarWrapper = document.getElementById('track-order-pizzabar-wrapper');
            const orderTableWrapper = document.getElementById('track-order-table-wrapper');
            
            if (pizzabarWrapper) {
                pizzabarWrapper.innerHTML = '';
            }
            if (orderTableWrapper) {
                orderTableWrapper.innerHTML = '';
            }
            
                const orderTableTemplate = document.getElementById('order-table-template');
                const orderTableClone = orderTableTemplate.content.cloneNode(true);
                const orderRows = orderTableClone.querySelectorAll('.boa-order-row');
                
                if (orderRows.length === 0) {
                    return;
                }
                
                const formattedDate = responseJson.orderDate 
                    ? new Date(responseJson.orderDate).toLocaleDateString('he-IL', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric'
                    })
                    : '';
                
                const freeText = 'Translation missing: he.products.product.free';
                const totalAmount = responseJson.totalAmount !== undefined ? parseFloat(responseJson.totalAmount) : null;
                const formattedTotal = totalAmount === null 
                    ? '' 
                    : `${totalAmount.toFixed(2)} ₪`;
                
                const statusValue = responseJson.status 
                    ? responseJson.status.toString() 
                    : getStatusFromChangeDates(responseJson.statusChangeDates);
                
                if (!statusValue) {
                    return;
                }
                
                const inProcessText = 'בתהליך עיבוד';
                const statusTranslations = {
                    '1': 'פתוח',
                    '2': 'פתוח',
                    '3': '',
                    '20': 'בליקוט',
                    '60': 'נסגר חלקי',
                    '61': 'Translation missing: he.customer.orders.status.61',
                    '62': 'Translation missing: he.customer.orders.status.62',
                    '70': 'נסגר מלא',
                    '80': 'נמסרה למשלח',
                    '81': '',
                    '90': 'נמסרה ללקוח',
                    '92': 'נאסף מסניף',
                    '95': 'בקשה לביטול',
                    '96': 'בוטל - אין במלאי',
                    '97': 'בוטל - לקוח',
                    '98': 'לא ניתן לבטל'
                };
                const statusText = statusTranslations[statusValue] || inProcessText;
                
                orderRows.forEach((orderRow) => {
                    const orderNameCell = orderRow.querySelector('.boa-row-name');
                    const orderDateCell = orderRow.querySelector('.boa-row-date');
                    const orderCountCell = orderRow.querySelector('.boa-row-count');
                    const orderTotalCell = orderRow.querySelector('.boa-row-total');
                    const orderStatusCell = orderRow.querySelector('.boa-row-status');
                    
                    if (orderNameCell) {
                        orderNameCell.textContent = orderName;
                    }
                    if (formattedDate && orderDateCell) {
                        orderDateCell.textContent = formattedDate;
                    }
                    if (orderCountCell) {
                        orderCountCell.textContent = responseJson.totalItemCount?.toString() || '0';
                    }
                    if (formattedTotal && orderTotalCell) {
                        orderTotalCell.textContent = formattedTotal;
                    }
                    if (orderStatusCell) {
                        orderStatusCell.textContent = statusText;
                    }
                });
                
                orderTableWrapper.appendChild(orderTableClone);
                orderTableContainer?.classList.remove('hide-down');
            
            const cancelledStatuses = ['96', '97'];
            if (cancelledStatuses.includes(statusValue)) {
                return;
            }
            
            const pizzabarTemplate = document.getElementById('pizzabar-template');
            if (!pizzabarWrapper || !pizzabarTemplate) {
                console.error('Missing required DOM elements');
                return;
            }

            const isPickup = responseJson.isPickup;
            
            const translations = {
                '1': 'הזמנה התקבלה',
                '2': 'הזמנה נארזה',
                '3': 'יצאה למשלוח',
                '4_delivery': 'נמסרה ללקוח',
                '4_pickup': 'משלוח ממתין לאיסוף'
            };
            
            const pizzabarClone = pizzabarTemplate.content.cloneNode(true);
            const pizzabar = pizzabarClone.querySelector('.boa-pizzabar');
            
            if (!pizzabar) {
                console.error('Template structure error');
                return;
            }
            
            // Set pickup attribute
            pizzabar.setAttribute('data-is-pickup', isPickup);
            
            // Show/hide pickup step (step 5)
            const pickupLine = pizzabar.querySelector('.pizzabar-line-pickup');
            const pickupStep = pizzabar.querySelector('.pizzabar-step-pickup');
            
            if (isPickup) {
                if (pickupLine) {
                    pickupLine.style.display = '';
                }
                if (pickupStep) {
                    pickupStep.style.display = '';
                }
            } else {
                if (pickupLine) {
                    pickupLine.style.display = 'none';
                }
                if (pickupStep) {
                    pickupStep.style.display = 'none';
                }
            }
            
            // Determine current step
            const order_received = ['1', '2', '3', '20'];
            const order_packed = ['60', '61', '62', '70'];
            const out_for_delivery = ['80', '81'];
            const shipment_arrived_store = ['92'];
            const delivered_to_customer = ['90'];
            let current = 1;
            if (order_received.includes(statusValue)) {
                current = 1;
            } else if (order_packed.includes(statusValue)) {
                current = 2;
            } else if (out_for_delivery.includes(statusValue)) {
                current = 3;
            } else if (shipment_arrived_store.includes(statusValue) && isPickup) {
                current = 4;
            } else if (shipment_arrived_store.includes(statusValue)) {
                current = 3;
            } else if (delivered_to_customer.includes(statusValue) && isPickup) {
                current = 5;
            } else if (delivered_to_customer.includes(statusValue)) {
                current = 4;
            }
            pizzabar.setAttribute('data-current', current);
            
            const stepTitles = pizzabar.querySelectorAll('.step-title');
            const stepDates = pizzabar.querySelectorAll('.step-date');
            
            // Update step 1
            if (stepTitles.length > 0 && stepDates.length > 0) {
                stepTitles[0].textContent = translations[1];
                stepDates[0].textContent = responseJson.statusChangeDates['1'] || '';
            }
            
            // Update step 2
            if (stepTitles.length > 1 && stepDates.length > 1) {
                stepTitles[1].textContent = translations[2];
                stepDates[1].textContent = responseJson.statusChangeDates['20'] || '';
            }
            
            // Update step 3
            if (stepTitles.length > 2 && stepDates.length > 2) {
                stepTitles[2].textContent = translations[3];
                stepDates[2].textContent = responseJson.statusChangeDates['80'] || '';
            }
            
            // Update step 4 (delivery or pickup intermediate)
            if (stepTitles.length > 3 && stepDates.length > 3) {
                if (isPickup) {
                    stepTitles[3].textContent = translations['4_pickup'];
                    stepDates[3].textContent = responseJson.statusChangeDates['92'] || '';
                } else {
                    stepTitles[3].textContent = translations['4_delivery'];
                    stepDates[3].textContent = responseJson.statusChangeDates['90'] || '';
                }
            }
            
            // Update step 5 (pickup final delivery)
            if (isPickup && stepTitles.length > 4 && stepDates.length > 4) {
                stepTitles[4].textContent = translations['4_delivery'];
                stepDates[4].textContent = responseJson.statusChangeDates['90'] || '';
            }
            
            pizzabarWrapper.appendChild(pizzabar);
            pizzabarContainer?.classList.remove('hide-down');
        } catch (error) {
            let errorMessageText = 'שגיאה בטעינת פרטי ההזמנה. אנא בדוק את הפרטים שהזנת ונסה שוב.';
            
            if (error.message && error.message !== 'שגיאה בטעינת פרטי ההזמנה. אנא בדוק את הפרטים שהזנת ונסה שוב.' && error.message !== 'הזמנה לא נמצאה. אנא בדוק את כתובת המייל ומספר ההזמנה שהזנת.') {
                errorMessageText = error.message;
            }
            
            if (errorText) {
                errorText.textContent = errorMessageText;
            }
            if (errorMessage) {
                errorMessage.classList.remove('hide-down');
            }

        } finally {
            setSubmitButtonLoading(false);
        }
    });
}
